import MongoModel from './MongoModel'
import { required, string } from 'vue-mc/validation'

import store from '@/store'

export default class Resource extends MongoModel {
  modelName = 'Resource'
  collection = 'resources'
  autoFields = true

  defaults () {
    const customProperties = {}
    for (const prop of store.getters['organizations/customProperties']('resource')) {
      customProperties[prop.key] = null
    }

    return {
      id: null,
      name: null,
      organization: null,
      ...customProperties
    }
  }

  mutations () {
    return {
    }
  }

  validation () {
    return {
      name: string.and(required),
      organization: string.and(required)
    }
  }
}
